import { useTranslation } from 'react-i18next';
import StatusBadge from './StatusBadge';
import { currency, dateTime } from '../../utils/formatters';

/**
 * One booking row. `perspective` = 'client' | 'technician'.
 * `actions` is an array of { label, status, tone } the current user may apply.
 */
export default function BookingCard({ booking, perspective = 'client', actions = [], onAction, onReview, busy }) {
  const { t } = useTranslation();
  const other =
    perspective === 'client'
      ? { name: booking.technicianName, sub: booking.technicianTypeName }
      : { name: booking.clientName, sub: booking.clientPhone };

  return (
    <div className="card pad stack" style={{ gap: '.6rem' }}>
      <div className="spread">
        <div>
          <strong>{other.name}</strong>{' '}
          <span className="muted" style={{ fontSize: '.88rem' }}>· {other.sub}</span>
        </div>
        <StatusBadge status={booking.status} />
      </div>
      <p>{booking.description}</p>
      {booking.status === 'REJECTED' && booking.rejectionReason && (
        <p className="muted" style={{ fontSize: '.88rem' }}>{t('booking.reason')}: {booking.rejectionReason}</p>
      )}
      <div className="row" style={{ gap: '1.5rem', fontSize: '.88rem' }}>
        <span className="muted"><i className="bi bi-calendar-event" /> {dateTime(booking.scheduledDate)}</span>
        {booking.clientAddress && <span className="muted"><i className="bi bi-geo-alt" /> {booking.clientAddress}</span>}
        {booking.estimatedCost != null && <span className="muted">{t('booking.estimated')} {currency(booking.estimatedCost)}</span>}
        {booking.actualCost != null && <span>{t('booking.final')} {currency(booking.actualCost)}</span>}
      </div>

      {(actions.length > 0 || (perspective === 'client' && booking.status === 'COMPLETED' && !booking.reviewed)) && (
        <div className="row" style={{ gap: '.5rem' }}>
          {actions.map((a) => (
            <button
              key={a.status}
              className={`btn sm ${a.tone || 'ghost'}`}
              disabled={busy}
              onClick={() => onAction(booking, a.status)}
            >
              {a.label || t(`booking.actions.${a.status}`, { defaultValue: a.status })}
            </button>
          ))}
          {perspective === 'client' && booking.status === 'COMPLETED' && !booking.reviewed && (
            <button className="btn sm accent" disabled={busy} onClick={() => onReview(booking)}>
              {t('client.leaveReview')}
            </button>
          )}
        </div>
      )}
      {perspective === 'client' && booking.reviewed && (
        <span className="badge green" style={{ alignSelf: 'flex-start' }}>{t('client.reviewed')}</span>
      )}
    </div>
  );
}
